import React from "react";
import { EuroCircleFilled } from "@ant-design/icons";
import { Row, Col, Typography, Tag } from "antd";
const { Title, Paragraph } = Typography;
const Achievements = () => {
  return (
    <Row>
      <Col span={24}>
        <Row justify={"space-between"}>
          <Col span={24}>
            <Tag
              color="gold-inverse"
              style={{ marginTop: "20px", marginBottom: "10px" }}
            >
              Categoria 1
            </Tag>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 1
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 2
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 3
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 4
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 5
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 6
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 7
            </Title>
          </Col>
          <Col span={24}>
            <Tag
              color="gold-inverse"
              style={{ marginTop: "20px", marginBottom: "10px" }}
            >
              Categoria 1
            </Tag>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 1
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 2
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 3
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 4
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 5
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 6
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 7
            </Title>
          </Col>
          <Col span={24}>
            <Tag
              color="gold-inverse"
              style={{ marginTop: "20px", marginBottom: "10px" }}
            >
              Categoria 1
            </Tag>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 1
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 2
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 3
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 4
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 5
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 6
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 7
            </Title>
          </Col>
          <Col span={24}>
            <Tag
              color="gold-inverse"
              style={{ marginTop: "20px", marginBottom: "10px" }}
            >
              Categoria 1
            </Tag>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 1
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 2
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 3
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 4
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 5
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "#faad14" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 6
            </Title>
          </Col>
          <Col offset={1}>
            <EuroCircleFilled style={{ fontSize: "100px", color: "grey" }} />
            <Title level={4} style={{ textAlign: "center" }}>
              Logro 7
            </Title>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Achievements;
